import React, { useState } from 'react';
import { FileUpload } from './FileUpload';

export const PdfQA = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFilesUploaded = (files) => {
    setUploadedFiles(files);
  };

  const askQuestion = async () => {
    if (!question.trim() || uploadedFiles.length === 0) return;

    setLoading(true);
    setAnswer('');

    try {
      const formData = new FormData();
      formData.append('question', question);
      
      // Ajouter tous les fichiers PDF
      uploadedFiles.forEach((fileData) => {
        formData.append('file', fileData.file);
      });

      //const res = await fetch('http://localhost:8080/process-pdf', {
      const res = await fetch('https://ai-project-backend-654802439092.europe-west9.run.app/process-pdf', {
        method: 'POST',
        body: formData, // Envoyer FormData au lieu de JSON
      });

      if (!res.ok) throw new Error(res.error);

      const data = await res.json();
			const rawAnswer = data.vertex_ai_response?.content?.parts?.[0]?.text;
			const answer = rawAnswer.replace(/\\n/g, '\n');

      setAnswer(answer || 'No answer returned.');
    } catch (error) {
      setAnswer('Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <FileUpload onFilesUploaded={handleFilesUploaded} />

      <div>
        <label htmlFor="question" className="block font-medium mb-1">Posez votre question:</label>
        <textarea
          id="question"
          rows={3}
          className="w-full rounded border p-2"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="Posez votre question ici..."
        />
      </div>

      <button
        className="px-4 py-2 bg-primary text-white rounded disabled:opacity-50"
        disabled={loading || uploadedFiles.length === 0 || !question.trim()}
        onClick={askQuestion}
      >
        {loading ? 'En cours...' : 'Poser la question'}
      </button>

      {answer && (
        <div className="mt-6 p-4 bg-muted rounded">
          <h3 className="font-semibold mb-2">Réponse:</h3>
					<p>{answer}</p>
        </div>
      )}
    </div>
  );
};
